import { BaseType, BaseTypeLiterals } from "../../../domain/base/base-type";

type ResourceLoadingStateLiterals =
  | "LOADING"
  | "LOAD_FAILED"
  | "HAS_PERMISSION"
  | "NO_PERMISSION";

export type ResourceLoadingStateMatcher<R> = BaseTypeLiterals<
  ResourceLoadingStateLiterals,
  R
>;

/**
 * 画面の表示状態を表す
 */
export class ResourceLoadingState extends BaseType<ResourceLoadingStateLiterals> {
  static isLoading() {
    return new ResourceLoadingState("LOADING");
  }

  static isLoadFailed() {
    return new ResourceLoadingState("LOAD_FAILED");
  }

  static hasPermission() {
    return new ResourceLoadingState("HAS_PERMISSION");
  }

  static noPermission() {
    return new ResourceLoadingState("NO_PERMISSION");
  }
}
